export const GET_COMMON_DASHBOARD = "GET_COMMON_DASHBOARD";
export const SET_COMMON_DASHBOARD_APPS = "SET_COMMON_DASHBOARD_APPS";
export const ADD_APP_FAV = "ADD_APP_FAV";
export const SET_ADD_APP_FAV = "SET_ADD_APP_FAV";
export const SET_LOADING = "SET_LOADING";
export const GET_NEWS_AND_ANNOUNCEMENT = "GET_NEWS_AND_ANNOUNCEMENT";
export const SET_NEWS_AND_ANNOUNCEMENT = "SET_NEWS_AND_ANNOUNCEMENT";
export const SET_ATTACHMENTS = "SET_ATTACHMENTS";
export const TOGGLE_ATTACHMENTS_LOADING = "TOGGLE_ATTACHMENTS_LOADING";
export const UPLOAD_ATTACHMENTS = "UPLOAD_ATTACHMENTS";
export const REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT";
export const GLOBAL_LOADER_TEXT = "GLOBAL_LOADER_TEXT";
